import ReadMoreInline from './ReadMoreInline.vue';
import InitComponent from 'Modules/InitComponent';

const readMoreInlineElements = document.getElementsByClassName(
  'read-more-inline__vue'
);
const initComponent = new InitComponent({
  selectors: readMoreInlineElements,
  components: { ReadMoreInline },
  template: '<ReadMoreInline />',
});

initComponent.init();
